<div class="wrapper">
  <div class="container-fluid">

    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item"><a href="javascript: void(0);" routerLink="/management/merchant">Merchant</a></li>
              <li class="breadcrumb-item active" *ngIf="!creatingNew">Edit Merchant</li>
              <li class="breadcrumb-item active" *ngIf="creatingNew">Add Merchant</li>
            </ol>
          </div>
          <h4 class="page-title">Merchant Management</h4>
        </div>
      </div>
    </div>
    <!-- end page title -->
    <div class="row" *ngIf="!!addUpdateMerchant">
      <div class="col-12">
        <div class="card-box">
          <div *ngIf="raiseWarning">
            <ngb-alert [dismissible]="false">
              <strong>Warning!</strong> {{warning}}
            </ngb-alert>
          </div>
          <div *ngIf="!!raiseErrors">
            <ngb-alert type="danger" [dismissible]="false" style="width:100%">
              <strong>Error!</strong> {{errorMessage}}
            </ngb-alert>
          </div>


          <h4 class="header-title">Merchants </h4>
          <ul ngbNav #nav="ngbNav" class="nav nav-tabs" (activeIdChange)="initTable($event)">
            <!--[(activeId)]="active"-->
            <li [ngbNavItem]="1">
              <a ngbNavLink>Merchant Details</a>
              <ng-template ngbNavContent>
                <div *ngIf="!creatingNew">Edit merchant details for your current merchant</div>
                <div *ngIf="creatingNew">Create new merchant for your current participant</div>
                <br />
                <div class="row">
                  <div class="col-12">
                    <form class="form-horizontal" role="form" autocomplete="off">

                      <div class="form-group row">
                        <label for="shopName" class="col-3 col-form-label">Shop Name</label>
                        <div class="col-9">
                          <input [(formControl)]="shopName" (keypress)="omit_special_char($event)" class="form-control" id="shopName" placeholder="Shop name" maxlength="23">
                          <ul *ngIf="submitted || shopName.touched" class="parsley-errors-list filled">
                            <li *ngIf="shopName.hasError('required')" class="parsley-required">Shop name is required.</li>
                          </ul>
                        </div>
                      </div>

                      <div class="form-group row">
                        <label for="merchantNumber" class="col-3 col-form-label">Merchant Number</label>
                        <div class="col-9">
                          <input [(formControl)]="merchantNumber" [ngModelOptions]="{standalone: true}" id="merchantNumber" placeholder="Merchant number" required class="form-control" maxlength="15">
                          <ul *ngIf="submitted || merchantNumber.touched" class="parsley-errors-list filled">
                            <li *ngIf="merchantNumber.hasError('required')" class="parsley-required">Merchant number is required.</li>
                            <li *ngIf="merchantNumber.hasError('minlength')" class="parsley-error">Merchant number must be atleast 15 characters.</li>
                          </ul>
                        </div>

                      </div>

                      <div class="form-group row">
                        <label for="cardAcceptorConfig" class="col-3 col-form-label">Merchant config</label>
                        <div class="col-9">
                          <ng-select2 id="cardAcceptorConfig" [formControl]="cardAcceptorConfigFormControl" [ngModelOptions]="{standalone: true}" [data]="cardAcceptorConfigs" [options]="select2options" (valueChanged)="updateForm()"></ng-select2>
                          <ul *ngIf="submitted || cardAcceptorConfigFormControl.touched" class="parsley-errors-list filled">
                            <li *ngIf="cardAcceptorConfigFormControl.hasError('required')" class="parsley-required">Card acceptor config is required.</li>
                          </ul>
                        </div>

                      </div>

                      <div class="form-group row">
                        <label for="cardSet" class="col-3 col-form-label">Card Set</label>
                        <div class="col-9">
                          <ng-select2 id="cardSet" [(formControl)]="cardSetFormControl" [ngModelOptions]="{standalone: true}" [data]="cardSets" [options]="select2options"></ng-select2>
                          <ul *ngIf="submitted || cardSetFormControl.touched" class="parsley-errors-list filled">
                            <li *ngIf="cardSetFormControl.hasError('required')" class="parsley-required">Card set is required.</li>
                          </ul>
                        </div>
                      </div>

                      <div class="form-group row">
                        <label for="countryCode" class="col-3 col-form-label">Are you a governmental merchant?</label>
                        <div class="col-9">
                          <ng-select2 id="governmentalConditionFormControl" [(formControl)]="governmentalConditionFormControl" [ngModelOptions]="{standalone: true}" [data]="governmentalOptions" [options]="select2options" (valueChanged)="updateFormValues()"></ng-select2>
                        </div>
                      </div>

                      <div class="form-group row" *ngIf="displayCountryCode">
                        <label for="countryCode" class="col-3 col-form-label">Country code</label>
                        <div class="col-9">
                          <input [(formControl)]="countryOfCodeFormControl" disabled="disabled" class="form-control" id="countryCode" placeholder="Country Code" maxlength="3">
                        </div>
                      </div>

                      <div class="form-group row">
                        <label for="countryCode" class="col-3 col-form-label">Country</label>
                        <div class="col-9">
                          <ng-select2 id="country" [(formControl)]="countryFormControl" [ngModelOptions]="{standalone: true}" [data]="countries" [options]="select2options" (valueChanged)="updateCountryCodeValue($event)"></ng-select2>
                          <ul *ngIf="submitted || countryFormControl.touched" class="parsley-errors-list filled">
                            <li *ngIf="countryFormControl.hasError('required')" class="parsley-required">Country is required.</li>
                          </ul>
                        </div>
                      </div>

                      <div class="form-group row">
                        <label for="regionCode" class="col-3 col-form-label">Region</label>
                        <div class="col-9">
                          <ng-select2 id="regionCode" [(formControl)]="regionFormControl" [ngModelOptions]="{standalone: true}" [data]="regions" [options]="select2options" (valueChanged)="loadAreas($event)"></ng-select2>
                          <ul *ngIf="submitted || regionFormControl.touched" class="parsley-errors-list filled">
                            <li *ngIf="regionFormControl.hasError('required')" class="parsley-required">Region is required.</li>
                          </ul>
                        </div>
                      </div>

                      <div class="form-group row">
                        <label for="city" class="col-3 col-form-label">City</label>
                        <div class="col-9">
                          <ng-select [items]="areaData"
                                     [virtualScroll]="true"
                                     [loading]="loading"
                                     bindLabel="Area"
                                     placeholder="Select City"
                                     appendTo="body"
                                     [(ngModel)]="selectedArea"
                                     name="city"
                                     (ngModelChange)="onCitySelected(selectedArea)"
                                     (scroll)="onScroll($event)"
                                     (scrollToEnd)="onScrollToEnd()">
                            <ng-template ng-header-tmp>
                              <small class="form-text text-muted">Loaded {{areaBuffer.length}} of {{areaData.length}}</small>
                            </ng-template>
                            <ng-template ng-option-tmp let-item="item" let-index="index">
                              <span>{{item.Area}} - {{item.Suburb}} (<span><b>{{item.StrCode}}</b></span><span *ngIf="item.StrCode == null"><b>{{item.BoxCode}}</b></span>)</span>
                            </ng-template>
                          </ng-select>
                          <ul *ngIf="submitted || city.touched" class="parsley-errors-list filled">
                            <li *ngIf="city.hasError('required')" class="parsley-required">City is required.</li>
                          </ul>
                        </div>
                      </div>

                      <div class="form-group row">
                        <label for="town" class="col-3 col-form-label">Town</label>
                        <div class="col-9">
                          <input [(formControl)]="town"
                                 id="town"
                                 class="form-control"
                                 placeholder="Town">
                        </div>
                      </div>

                      <div class="form-group row">
                        <label for="postalServiceCode" class="col-3 col-form-label">Postal Service Code</label>
                        <div class="col-9">
                          <input [(formControl)]="postalServiceCode" id="postalServiceCode" class="form-control" maxlength="4" placeholder="">
                          <ul *ngIf="submitted || postalServiceCode.touched" class="parsley-errors-list filled">
                            <li *ngIf="postalServiceCode.hasError('required')" class="parsley-required">Postal service code is required.</li>
                          </ul>
                        </div>
                      </div>

                      <div class="form-group row">
                        <label for="merchantType" class="col-3 col-form-label">Merchant Type <i class="fe-info" placement="top" ngbTooltip="Also known as MMC"></i></label>
                        <div class="col-9">
                          <ng-select2 id="merchantType" [(formControl)]="merchantTypeFormControl" [ngModelOptions]="{standalone: true}" [data]="merchantTypes" [options]="select2options"></ng-select2>
                          <ul *ngIf="submitted || merchantTypeFormControl.touched" class="parsley-errors-list filled">
                            <li *ngIf="merchantTypeFormControl.hasError('required')" class="parsley-required">Merchant type is required.</li>
                          </ul>
                        </div>
                      </div>

                      <div class="form-group row" *ngIf="displaySubMerchantId">
                        <label for="subMerchantId" class="col-3 col-form-label">Sub Merchant ID<i class="fe-info" placement="top" ngbTooltip="Client facing Merchant number for aggregator merchants, Please populate with 15 zeros for ISO merchants"></i></label>
                        <div class="col-9">
                          <input [(formControl)]="subMerchantId" id="subMerchantId" class="form-control" maxlength="15" placeholder="">
                          <ul *ngIf="submitted || displayIsoContentError || subMerchantId.dirty || subMerchantId.touched" class="parsley-errors-list filled">
                            <li *ngIf="subMerchantId.value == ''" class="parsley-required">Sub Merchant ID is required.</li>
                            <li *ngIf="subMerchantId.hasError('minlength')" class="parsley-error">Sub Merchant Id must be atleast 15 characters.</li>
                          </ul>
                        </div>
                      </div>

                      <div class="form-group row" *ngIf="displayPaymentFacilitatorId">
                        <label for="paymentFacilitatorId" class="col-3 col-form-label">Payment Facilitator ID<i class="fe-info" placement="top" ngbTooltip="PFID provided by bank when Aggregator after registered with VISA/MC"></i></label>
                        <div class="col-9">
                          <input [(formControl)]="paymentFacilitatorId" id="paymentFacilitatorId" class="form-control" maxlength="11" placeholder="" (valueChanged)="updateFormValues()">
                          <ul *ngIf="submitted || displayIsoContentError || paymentFacilitatorId.touched" class="parsley-errors-list filled">
                            <li *ngIf="paymentFacilitatorId.value == ''" class="parsley-required">Payment Facilitator ID is required.</li>
                          </ul>
                        </div>

                      </div>

                      <div class="form-group row" *ngIf="displayPaymentFacilitatorIdVisa">
                        <label for="paymentFacilitatorIdVisa" class="col-3 col-form-label">Payment Facilitator ID VISA</label>
                        <div class="col-9">
                          <input [(formControl)]="paymentFacilitatorIdVisa" id="paymentFacilitatorIdVisa" class="form-control" maxlength="11" placeholder="">
                          <ul *ngIf="submitted || displayIsoContentError || paymentFacilitatorIdVisa.dirty || paymentFacilitatorIdVisa.touched" class="parsley-errors-list filled">
                            <li *ngIf="paymentFacilitatorIdVisa.value == ''" class="parsley-required">Payment Facilitator ID VISA is required.</li>
                          </ul>
                        </div>
                      </div>

                      <div class="form-group row" *ngIf="displayIndependentSalesOrganizationId">
                        <label for="independentSalesOrganizationId" class="col-3 col-form-label">Independent Sales Organization ID   <i class="fe-info" placement="top" ngbTooltip="For ISO Merchants only this field should be populated with the same value as the Mastercard Payments Facilitator Details"></i></label>
                        <div class="col-9">
                          <input [(formControl)]="independentSalesOrganizationId" id="independentSalesOrganizationId" class="form-control" maxlength="11" placeholder="">
                          <ul *ngIf="submitted || independentSalesOrganizationId.dirty || independentSalesOrganizationId.touched" class="parsley-errors-list filled">
                            <li *ngIf="independentSalesOrganizationId.value == ''" class="parsley-required">Independent Sales Organization ID is required.</li>
                            <li *ngIf="independentSalesOrganizationId.hasError('minlength')" class="parsley-error">Independent Sales Organization ID must be atleast 11 characters.</li>
                          </ul>
                        </div>
                      </div>

                      <div class="form-group row" *ngIf="displayIndependentSalesOrganizationIdVisa">
                        <label for="independentSalesOrganizationIdVisa" class="col-3 col-form-label">Independent Sales Organization ID VISA </label>
                        <div class="col-9">
                          <input [(formControl)]="independentSalesOrganizationIdVisa" id="independentSalesOrganizationIdVisa" class="form-control" maxlength="11" placeholder="">
                          <ul *ngIf="submitted || displayIsoContentError || independentSalesOrganizationIdVisa.dirty || independentSalesOrganizationIdVisa.touched" class="parsley-errors-list filled">
                            <li *ngIf="independentSalesOrganizationIdVisa.value == ''" class="parsley-required">Independent Sales Organization ID VISA is required.</li>
                            <li *ngIf="independentSalesOrganizationIdVisa.hasError('minlength')" class="parsley-error">Independent Sales Organization ID VISA must be atleast 11 characters.</li>
                          </ul>
                        </div>
                      </div>

                      <div class="form-group row" *ngIf="displayCustomerServicePhoneNo">
                        <label for="customerServicePhoneNo" class="col-3 col-form-label">Customer Service Phone No <i class="fe-info" placement="top" ngbTooltip="Customer Service Phone Number should start with '27' i.e 27721234567"></i></label>
                        <div class="col-9">
                          <input [(formControl)]="customerServicePhoneNo" id="customerServicePhoneNo" class="form-control" minlength="11" maxlength="11" placeholder="">
                          <ul *ngIf="submitted || displayIsoContentError || customerServicePhoneNo.dirty || customerServicePhoneNo.touched" class="parsley-errors-list filled">
                            <li *ngIf="customerServicePhoneNo.value == ''" class="parsley-required">Customer Service Phone No is required.</li>
                            <li *ngIf="customerServicePhoneNo.hasError('minlength')" class="parsley-error">Customer Service Phone No must be atleast 11 characters.</li>
                          </ul>
                        </div>
                      </div>

                      <div class="form-group row" *ngIf="displayMerchantStreetAddress">
                        <label for="merchantStreetAddress" class="col-3 col-form-label">Street Address   <i class="fe-info" placement="top" ngbTooltip="48 characters and space-filled. No special Characters such as '"></i></label>
                        <div class="col-9">
                          <textarea rows="3" (keypress)="omit_special_char_for_address($event)" [(formControl)]="merchantStreetAddress" class="form-control" id="merchantStreetAddress" maxlength="48" placeholder="Street Address"></textarea>
                          <ul *ngIf=" submitted || displayIsoContentError || merchantStreetAddress.dirty || merchantStreetAddress.touched" class="parsley-errors-list filled">
                            <li *ngIf="merchantStreetAddress.value == ''" class="parsley-required">Street Address is required.</li>
                          </ul>
                        </div>
                      </div>

                      <div class="form-group row" *ngIf="displayMerchantVerificationValue">
                        <label for="merchantVerificationValue" class="col-3 col-form-label">Merchant Verification Value  <i class="fe-info" placement="top"></i></label>
                        <div class="col-9">
                          <input [(formControl)]="merchantVerificationValue" id="merchantVerificationValue" class="form-control" maxlength="10" placeholder="">
                          <ul *ngIf="submitted || displayIsoContentError || merchantVerificationValue.dirty || merchantVerificationValue.touched" class="parsley-errors-list filled">
                            <li *ngIf="merchantVerificationValue.value == ''" class="parsley-required">Merchant Verification Value is required.</li>
                            <li *ngIf="merchantVerificationValue.hasError('minlength')" class="parsley-error">Merchant Verification Value must be atleast 10 characters.</li>
                          </ul>
                        </div>
                      </div>

                      <div class="form-group row" *ngIf="displayContent">
                        <label for="slipHeader" class="col-3 col-form-label">Slip Header <i class="fe-info" placement="top" ngbTooltip="Header info may differ on slip/paper from the website. limits could be due to slip/paper width or OS limitations"></i></label>
                        <div class="col-9">
                          <textarea rows="4" cols="24" [(formControl)]="slipHeader" class="form-control" id="slipHeader" placeholder="Slip header" (input)="onSlipHeaderChange($event.target.value)"></textarea>
                        </div>
                      </div>

                      <div class="form-group row" *ngIf="displayContent">
                        <label for="slipTrailer" class="col-3 col-form-label">Slip Trailer <i class="fe-info" placement="top" ngbTooltip="Trailer info may differ on slip/paper from the website. limits could be due to slip/paper width or OS limitations"></i></label>
                        <div class="col-9">
                          <textarea rows="4" cols="24" [(formControl)]="slipTrailer" class="form-control" id="slipTrailer" placeholder="Slip trailer" (input)="onSlipTrailerChange($event.target.value)"></textarea>

                        </div>
                      </div>


                      <div class="form-group row" *ngIf="mappedFields.length > 0">
                        <label class="col-3 col-form-label">Mapped Field</label>
                        <div class="col-9">
                          <div class="input-group">
                            <ng-select2 id="mappedFields" class="select2-mapping" [(formControl)]="sinkNodeMappedFieldsFormControl" [ngModelOptions]="{standalone: true}" [data]="mappedFields" [options]="select2options"></ng-select2>
                            <div class="input-group-append">
                              <button class="btn btn-info waves-effect waves-light" (click)="addSinkNodeMappedFields()" type="button">Add MappedField <i class="mdi mdi-plus"></i></button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group row" *ngFor="let mappedField of mappedFieldsFC">
                        <label for="debit{{mappedField.sinkNodeMappedFields.mappedCardAcceptorId}}" class="col-3 col-form-label">{{mappedField.sinkNodeMappedFields.description}}</label>
                        <div class="col-9">
                          <div class="input-group">
                            <input [(formControl)]="mappedField.formControl" class="form-control" [ngModelOptions]="{standalone: true}" id="debit{{mappedField.sinkNodeMappedFields.mappedCardAcceptorId}}" placeholder="Mapped field" maxlength="15">
                            <div class="input-group-append" *ngIf="!mappedField.disabled">
                              <button class="btn btn-outline-warning  waves-effect waves-light" id="{{mappedField.sinkNodeMappedFields.description}}" (click)="deleteMappedField(mappedField.sinkNodeMappedFields.sinkNode)" type="button" [style]="viewOnlyRight"><i class="mdi mdi-delete"></i></button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group row" *ngIf="raiseSinkNodeMappingWarning">
                        <ngb-alert [dismissible]="false" style="width:100%">
                          <strong>Warning!</strong> {{raiseSinkNodeMappingWarningMessage}}
                        </ngb-alert>
                      </div>

                      <div class="form-group row" *ngIf="!!createResult && createResult.success == false">
                        <ngb-alert type="danger" [dismissible]="false" style="width:100%">
                          <strong>Error!</strong> {{createResult.message}}
                        </ngb-alert>
                      </div>

                    </form>
                  </div>

                </div>
              </ng-template>
            </li>
            <li [ngbNavItem]="2" [hidden]="viewBanking">
              <a ngbNavLink>Banking Details</a>
              <ng-template ngbNavContent>
                <div *ngIf="!creatingNew">Edit banking details for your current merchant</div>
                <div *ngIf="creatingNew">Add new banking details for your current merchant</div>
                <br />
                <div class="row">
                  <div class="col-12">
                    <form class="form-horizontal" role="form" autocomplete="off">

                      <div class="form-group row">
                        <label for="accountHolderName" class="col-3 col-form-label">Account Holder Name</label>
                        <div class="col-9">
                          <input [(formControl)]="accountHolderName" class="form-control" id="accountHolderName" name="accountHolderName" placeholder="Account holder name">
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="accountDescription" class="col-3 col-form-label">Account Description</label>
                        <div class="col-9">
                          <input [(formControl)]="accountDescription" class="form-control" id="accountDescription" name="accountDescription" placeholder="Account description">
                        </div>
                      </div>

                      <div class="form-group row">
                        <label for="bankID" class="col-3 col-form-label">Bank</label>
                        <div class="col-9">
                          <ng-select2 id="bankID" [(formControl)]="bankFormControl" [ngModelOptions]="{standalone: true}" [data]="banks" [options]="select2options"></ng-select2>
                        </div>
                      </div>

                      <div class="form-group row">
                        <label for="accountTypeID" class="col-3 col-form-label">Account Type</label>
                        <div class="col-9">
                          <ng-select2 id="accountTypeID" [(formControl)]="accountTypeFormControl" [ngModelOptions]="{standalone: true}" [data]="accountTypes" [options]="select2options"></ng-select2>
                        </div>
                      </div>

                      <div class="form-group row">
                        <label for="branchCode" class="col-3 col-form-label">Branch Code</label>
                        <div class="col-9">
                          <input [(formControl)]="branchCode" class="form-control" id="branchCode" placeholder="Branch code">
                          <ul *ngIf="submitted || branchCode.dirty || branchCode.touched" class="parsley-errors-list filled">
                            <li *ngIf="branchCode.invalid" class="parsley-error">Branch code must be non zero and contain only numbers.</li>
                          </ul>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="branchName" class="col-3 col-form-label">Branch Name</label>
                        <div class="col-9">
                          <input [(formControl)]="branchName" class="form-control" id="branchName" placeholder="Branch name">
                        </div>
                      </div>

                      <div class="form-group row">
                        <label for="accountNumber" class="col-3 col-form-label">Account Number</label>
                        <div class="col-9">
                          <input [(formControl)]="accountNumber" class="form-control" id="accountNumber" placeholder="Account number" minlength="9" maxlength="15">
                          <ul *ngIf="submitted || accountNumber.dirty || accountNumber.touched" class="parsley-errors-list filled">
                            <li *ngIf="accountNumber.invalid" class="parsley-error">Account number must be at least 9 characters long, non zero and contain only numbers.</li>
                          </ul>
                        </div>
                      </div>

                      <div class="form-group row" *ngIf="!!createResult && createResult.success == false">
                        <ngb-alert type="danger" [dismissible]="false" style="width:100%">
                          <strong>Error!</strong> {{createResult.message}}
                        </ngb-alert>
                      </div>

                    </form>
                  </div>
                </div>
              </ng-template>
            </li>
            <li [ngbNavItem]="3" [hidden]="viewContact">
              <a ngbNavLink>Contact Details</a>
              <ng-template ngbNavContent>
                <div *ngIf="!creatingNew">Edit contact details for your current merchant</div>
                <div *ngIf="creatingNew">Add new contact details for your current merchant</div>
                <br />
                <div class="row">
                  <div class="col-12">
                    <form class="form-horizontal" role="form" autocomplete="off">

                      <div class="form-group row">
                        <label for="contactName" class="col-3 col-form-label">Contact Name</label>
                        <div class="col-9">
                          <input [(formControl)]="contactName" class="form-control" id="contactName" placeholder="Contact name">
                        </div>
                      </div>

                      <div class="form-group row">
                        <label for="contactSurname" class="col-3 col-form-label">Contact Surname</label>
                        <div class="col-9">
                          <input [(formControl)]="contactSurname" class="form-control" id="contactSurname" placeholder="Contact surname">
                        </div>
                      </div>

                      <div class="form-group row">
                        <label for="contactNumber" class="col-3 col-form-label">Contact Number</label>
                        <div class="col-9">
                          <input [(formControl)]="contactNumber" class="form-control" id="contactNumber" placeholder="Contact number">
                        </div>
                      </div>

                      <div class="form-group row">
                        <label for="cellNumber" class="col-3 col-form-label">Cell Number</label>
                        <div class="col-9">
                          <input [(formControl)]="cellNumber" class="form-control" id="cellNumber" placeholder="Cell number">
                        </div>
                      </div>

                      <div class="form-group row">
                        <label for="emailAddress" class="col-3 col-form-label">E-Mail Address</label>
                        <div class="col-9">
                          <input [(formControl)]="emailAddress" class="form-control" id="emailAddress" placeholder="Email address" type="email">
                          <ul *ngIf="submitted || emailAddress.touched" class="parsley-errors-list filled">
                            <li *ngIf="emailAddress.hasError('email')" class="parsley-required">Please enter valid email address.</li>
                          </ul>
                        </div>
                      </div>

                      <div class="form-group row">
                        <label for="url" class="col-3 col-form-label">Url</label>
                        <div class="col-9">
                          <input [(formControl)]="url" class="form-control" id="url" placeholder="Url">
                        </div>
                      </div>

                      <div class="form-group row" *ngIf="!!createResult && createResult.success == false">
                        <ngb-alert type="danger" [dismissible]="false" style="width:100%">
                          <strong>Error!</strong> {{createResult.message}}
                        </ngb-alert>
                      </div>

                    </form>
                  </div>

                </div>
              </ng-template>
            </li>
            <li [ngbNavItem]="4" [hidden]="viewCommission">
              <a ngbNavLink>Commission Details</a>
              <ng-template ngbNavContent>
                <div *ngIf="!creatingNew">Edit commission details for your current merchant</div>
                <div *ngIf="creatingNew">Add new commission details for your current merchant</div>
                <div class="form-group row" *ngFor="let com of commissionFC">

                  <label for="debit{{com.commissionDetails.commision}}" class="col-3 col-form-label">{{com.commissionDetails.name}}</label>
                  <div class="col-9">
                    <div class="input-group">
                      <input type="number" [(formControl)]="com.formControl" class="form-control" [ngModelOptions]="{standalone: true}" id="debit{{com.commissionDetails.commision}}" placeholder="Commission">
                      <div class="input-group-append">
                        <button class="btn btn-outline-warning  waves-effect waves-light" (click)="deleteCommission(com.commissionDetails.cardID)" type="button" [style]="viewOnlyRight"><i class="mdi mdi-delete"></i></button>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="form-group row">
                  <label class="col-3 col-form-label">New Commission</label>

                  <div class="col-9">
                    <div class="input-group">
                      <ng-select2 id="cardTypes" class="select2-full" [(formControl)]="commissionFormControl" [ngModelOptions]="{standalone: true}" [data]="cardTypes" [options]="select2options"></ng-select2>
                      <div class="input-group-append">
                        <button class="btn btn-info waves-effect waves-light" (click)="addCommission()" type="button">Add Commission <i class="mdi mdi-plus"></i></button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group row" *ngIf="canConfigLoyaltyCommission">
                  <label for="loyaltyCommission" class="col-3 col-form-label">Loyalty Commission</label>
                  <div class="col-9">
                    <input type="number" [(formControl)]="loyaltyCommission" class="form-control" id="loyaltyCommission" placeholder="Loyalty commission">
                  </div>
                </div>

                <div class="form-group row" *ngIf="!!createResult && createResult.success == false">
                  <ngb-alert type="danger" [dismissible]="false" style="width:100%">
                    <strong>Error!</strong> {{createResult.message}}
                  </ngb-alert>
                </div>

              </ng-template>
            </li>
            <li [ngbNavItem]="5" [hidden]="viewAddedServices">
              <a ngbNavLink>Value Added Services</a>
              <ng-template ngbNavContent>

                <div class="form-group row col-12" *ngIf="lowBalance">
                  <label for="lowBalanceNotificationStatus" class="col-12 col-form-label alert-warning">WARNING: You have reached your Low Balance Threshold. </label>
                  <!--<div class="col-1 float-left">
            <input type="checkbox" [(formControl)]="lowBalanceNotificationStatus" class="checkbox-align" id="lowBalanceNotificationStatus" placeholder="Low balance notification status" disabled="disabled" />
          </div>-->
                </div>

                <div class="form-group row">
                  <label for="lowBalanceThreshold" class="col-3 col-form-label">Low Balance Threshold</label>
                  <div class="col-9">
                    <input type="number" [(formControl)]="lowBalanceThreshold" class="form-control" id="lowBalanceThreshold" placeholder="Low balance threshold">
                  </div>
                </div>

                <div class="form-group row">
                  <label for="customerSystemID" class="col-3 col-form-label">Customer system Id</label>
                  <div class="col-9">
                    <input type="text" [(formControl)]="customerSystemID" class="form-control" id="customerSystemID" placeholder="Customer system Id" disabled="disabled">
                  </div>
                </div>

                <div class="form-group row">
                  <label for="currentBalance" class="col-3 col-form-label">Current balance</label>
                  <div class="col-9">
                    <input type="number" [(formControl)]="currentBalance" class="form-control" id="currentBalance" placeholder="Current balance" disabled="disabled">
                  </div>
                </div>

                <div class="form-group row" *ngIf="!!createResult && createResult.success == false">
                  <ngb-alert type="danger" [dismissible]="false" style="width:100%">
                    <strong>Error!</strong> {{createResult.message}}
                  </ngb-alert>
                </div>

              </ng-template>
            </li>
            <li [ngbNavItem]="6" [hidden]="hideCustomServices">
              <a ngbNavLink>Custom Services</a>
              <ng-template ngbNavContent>
                <div>Edit service details for your current merchant</div>

                <div class="form-group row" *ngFor="let param of merchantParamsFC">
                  <label for="service{{param.serviceParameter.id}}" class="col-3 col-form-label">{{param.serviceParameter.name}}</label>
                  <div class="col-9">
                    <div class="input-group">
                      <input type="number" [(formControl)]="param.formControl" class="form-control" [ngModelOptions]="{standalone: true}" id="service{{param.merchantParam.service.id}}" placeholder="0">
                      <div class="input-group-append">
                        <button class="btn btn-outline-warning  waves-effect waves-light" (click)="deleteMerchantParam(param.merchantParam.service.id)" type="button" [style]="viewOnlyRight"><i class="mdi mdi-delete"></i></button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label for="services" class="col-3 col-form-label">Service</label>
                  <div class="col-9">
                    <div class="input-group">
                      <ng-select name="services" class="select-full" bindLabel="services" placeholder="List of services" [(formControl)]="serviceFormControl" [searchable]="true" #serviceSelect>
                        <ng-option [value]="service.id" *ngFor="let service of services">
                            {{service.text}}
                        </ng-option>
                      </ng-select>
                      <div class="input-group-append">
                        <button class="btn btn-info waves-effect waves-light" (click)="addMerchantParam()" type="button">Add Service <i class="mdi mdi-plus"></i></button>
                      </div>
                    </div>
                  </div>
                </div>

              </ng-template>
            </li>
          </ul>

          <div [ngbNavOutlet]="nav" class="tab-pane">
          </div>

          <div class="form-group mb-0 justify-content-end row">
            <div class="col-9">
              <button type="submit" [style]="AddEditButton" class="btn btn-info waves-effect waves-light float-right" (click)="save()">
                Save
              </button>
            </div>
          </div>
        </div>

      </div>

    </div>

  </div> <!-- end container -->
</div>






